
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93Q7Ly_7zm5sQu9nmN4Nc9O73FpEVtVJQHmk3okIVYD1MMeta } from "/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue?macro=true";
import { default as _91location_93Yx7dl4gVsMJk72pJG2Vu1d_1OcZD0JAaj5MnkIdiEK4Meta } from "/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue?macro=true";
import { default as _91product_id_93818iOMcjfmC7tHwH0mAlfQUfFtdbdRzFGoykY6pSa04Meta } from "/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue?macro=true";
import { default as component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta } from "/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@8.57.1_ioredis@_d623f5b89527cb8e62ae7e220e6d04b5/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII } from "/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@8.57.1_ioredis@_d623f5b89527cb8e62ae7e220e6d04b5/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___us",
    path: "/us/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___au",
    path: "/au/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ca",
    path: "/ca/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ie",
    path: "/ie/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___nz",
    path: "/nz/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___za",
    path: "/za/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___cl",
    path: "/cl/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ar",
    path: "/ar/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___mx",
    path: "/mx/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ca-fr",
    path: "/ca-fr/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ch-fr",
    path: "/ch-fr/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___br",
    path: "/br/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___be-nl",
    path: "/be-nl/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___hu",
    path: "/hu/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___cy",
    path: "/cy/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___gr",
    path: "/gr/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___jp",
    path: "/jp/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "type-location___us",
    path: "/us/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___uk",
    path: "/uk/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___au",
    path: "/au/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ca",
    path: "/ca/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ie",
    path: "/ie/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___nz",
    path: "/nz/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___za",
    path: "/za/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___es",
    path: "/es/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___cl",
    path: "/cl/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ar",
    path: "/ar/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___mx",
    path: "/mx/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___fr",
    path: "/fr/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ca-fr",
    path: "/ca-fr/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___be",
    path: "/be/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___de",
    path: "/de/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ch",
    path: "/ch/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ch-fr",
    path: "/ch-fr/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___at",
    path: "/at/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___pt",
    path: "/pt/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___br",
    path: "/br/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___it",
    path: "/it/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___nl",
    path: "/nl/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___be-nl",
    path: "/be-nl/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___pl",
    path: "/pl/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___hu",
    path: "/hu/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___cy",
    path: "/cy/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___gr",
    path: "/gr/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___jp",
    path: "/jp/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___en",
    path: "/:type()/:location()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-country-product-product_id___us",
    path: "/us/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___uk",
    path: "/uk/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___au",
    path: "/au/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ca",
    path: "/ca/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ie",
    path: "/ie/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___nz",
    path: "/nz/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___za",
    path: "/za/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___es",
    path: "/es/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___cl",
    path: "/cl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ar",
    path: "/ar/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___mx",
    path: "/mx/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___fr",
    path: "/fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ca-fr",
    path: "/ca-fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___be",
    path: "/be/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___de",
    path: "/de/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ch",
    path: "/ch/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ch-fr",
    path: "/ch-fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___at",
    path: "/at/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___pt",
    path: "/pt/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___br",
    path: "/br/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___it",
    path: "/it/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___nl",
    path: "/nl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___be-nl",
    path: "/be-nl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___pl",
    path: "/pl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___hu",
    path: "/hu/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___cy",
    path: "/cy/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___gr",
    path: "/gr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___jp",
    path: "/jp/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___en",
    path: "/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src3040968747/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/us/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/uk/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/au/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ca/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ie/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/nz/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/za/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/cl/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/mx/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ca-fr/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/be/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ch/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/ch-fr/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/at/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/br/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/be-nl/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/pl/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/hu/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/cy/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/gr/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/jp/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  },
  {
    name: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEIIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubq8QEzhidl2vKcJypJ9iQVHoTT2JvTO7p6QPnGqwdEII
  }
]